import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import {
  Box,
  TextField,
  FormControl,
  Grid,
  Button,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Tooltip,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { UpdateBonusConfigurationAction } from "../../../../../../store/Finance/PayRollTemplate/Action";

const StatutoryBonus = ({ editedRecord, setOpenPopup }) => {
  const dispatch = useDispatch();

  const initialValue = {
    bonus_percentage: "",
    payout_frequency: "",
    payout_month: "",
  };

  const [bonus, setBonus] = useState(initialValue);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (editedRecord) {
      setBonus({...editedRecord,
        payout_frequency: editedRecord?.bonus_credit_type_monthly ? "Monthly" : "Yearly"});
    }
  }, [editedRecord]);

  const validate = (fieldValues = bonus) => {
    let temp = { ...errors };

    if ("bonus_percentage" in fieldValues)
      temp.bonus_percentage =
        fieldValues.bonus_percentage === ""
          ? "Bonus percentage is required"
          : Number(fieldValues.bonus_percentage) >= 8.33 && Number(fieldValues.bonus_percentage) <= 20
            ? ""
            : "Must be between 8.33 and 20";

    if ("payout_frequency" in fieldValues)
      temp.payout_frequency = fieldValues.payout_frequency
        ? ""
        : "Payout frequency is required";

    if ("payout_month" in fieldValues && bonus.payout_frequency === "Yearly")
      temp.payout_month = fieldValues.payout_month
        ? ""
        : "Payout month is required";

    setErrors(temp);
    return Object.values(temp).every((x) => x === "");
  };

  const handleInput = (e) => {
    const { name, value } = e.target;

    setBonus({
      ...bonus,
      [name]: value,
    });

    if (Object.values(errors).some((x) => x !== "")) {
      validate({ ...bonus, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      let bonus_credit_type_monthly = false;
      if (bonus.payout_frequency === "Monthly") {
        bonus_credit_type_monthly = true;
      }
      dispatch(UpdateBonusConfigurationAction({
        ...bonus,
        bonus_credit_if_yearly_month: null,
        bonus_credit_type_monthly
      }))
      setOpenPopup(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2}>
        {/* Bonus Percentage */}
        <Grid item xs={12} md={6}>
          <TextField
            size="small"
            required
            type="number"
            name="bonus_percentage"
            label="Bonus (%)"
            value={bonus.bonus_percentage}
            onChange={handleInput}
            fullWidth
            inputProps={{ min: 0 }}
            InputProps={{
              endAdornment: (
                <Tooltip title="Percentage of salary paid as bonus. As per compliance, it typically ranges between 8.33% and 20%.">
                  <InfoOutlinedIcon fontSize="small" />
                </Tooltip>
              ),
            }}
            {...(errors.bonus_percentage && {
              error: true,
              helperText: errors.bonus_percentage,
            })}
          />
        </Grid>

        {/* Frequency */}
        <Grid item xs={12} md={6}>
          <FormControl fullWidth size="small" error={!!errors.payout_frequency}>
            <InputLabel>
              <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                Payout Frequency
                {/* <Tooltip title="If Monthly is selected, bonus is paid every month. If Yearly is selected, bonus is paid once in the chosen month."> */}
                <Tooltip title="If Monthly is selected, bonus is paid every month.">
                  <InfoOutlinedIcon
                    fontSize="small"
                    sx={{ cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            </InputLabel>
            <Select
              name="payout_frequency"
              value={bonus.payout_frequency}
              label="Payout Frequency"
              onChange={handleInput}
            >
              <MenuItem value="Monthly">Monthly</MenuItem>
              {/* <MenuItem value="Yearly">Yearly</MenuItem> */}
            </Select>
            <FormHelperText>{errors.payout_frequency}</FormHelperText>
          </FormControl>
        </Grid>

        {/* Month (only if yearly) */}
        {bonus.payout_frequency === "Yearly" && (
          <Grid item xs={12} md={6}>
            <FormControl fullWidth size="small" error={!!errors.payout_month}>
              <InputLabel>
                <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                  Payout Month
                  <Tooltip title="Bonus will be paid in the selected month once a year">
                    <InfoOutlinedIcon
                      fontSize="small"
                      sx={{ cursor: "pointer" }}
                    />
                  </Tooltip>
                </span>
              </InputLabel>
              <Select
                name="payout_month"
                value={bonus.payout_month}
                label="Payout Month"
                onChange={handleInput}
              >
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((month) => (
                  <MenuItem key={month} value={month}>
                    {month}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{errors.payout_month}</FormHelperText>
            </FormControl>
          </Grid>
        )}
      </Grid>

      <Box mt={3} display="flex" justifyContent="flex-end">
        <Button
            type="submit"
            variant="contained"
            size="medium"
            className="mpl-primary-btn"
        >
            {editedRecord ? "Update" : "Save"}
        </Button>
      </Box>
    </Box>
  );
};

export default StatutoryBonus;
